/* Mairaz - one-time WELCOME10 abandonment recovery offer.
   No framework. Native <dialog> so focus handling, Escape, focus restore and
   top-layer stacking (above the fixed WhatsApp button) come from the platform.

   Frequency: at most once per browsing session (sessionStorage).
   Desktop trigger: pointer leaves the viewport across the top edge.
   Touch trigger:   ONE self-disarming history sentinel. It can absorb at most
                    one Back press, is never re-pushed, and if the offer cannot
                    be shown the Back press is completed for the customer.
                    There is no loop and no repeated interception. */
(function () {
  'use strict';

  var STORAGE_KEY = 'mrzExitOfferSeen';
  var dialog = document.getElementById('MrzExitOffer');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var fired = false;
  var backArmed = false;

  function seen() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return true; /* storage unavailable: fail closed, never nag */
    }
  }

  function markSeen() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  function currentPath() {
    var p = (window.location.pathname || '/').toLowerCase();
    p = p.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/, ''); /* market / locale prefix */
    return p === '' ? '/' : p;
  }

  function onBlockedPage() {
    var p = currentPath();
    return (
      p.indexOf('/checkout') === 0 ||
      p.indexOf('/checkouts') === 0 ||
      p.indexOf('/pages/checkout-terms') === 0 ||
      p.indexOf('/account') === 0 ||
      p.indexOf('/orders') === 0 ||
      p.indexOf('/tools/') === 0 ||
      p.indexOf('/apps/') === 0
    );
  }

  /* Dawn keeps hidden aria-modal nodes (search modal, cart notification) in the
     DOM at all times, so presence alone is not enough - they must be rendered. */
  function isVisible(el) {
    if (!el) return false;
    if (!el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }

  function otherOverlayOpen() {
    var i;
    var gates = document.querySelectorAll('.mrz-gate'); /* Terms gate */
    for (i = 0; i < gates.length; i++) {
      if (isVisible(gates[i])) return true;
    }
    var dialogs = document.querySelectorAll('dialog[open]');
    for (i = 0; i < dialogs.length; i++) {
      if (dialogs[i] !== dialog) return true;
    }
    var modals = document.querySelectorAll('[aria-modal="true"], .modal__content[open], cart-drawer.active, .menu-drawer-container details[open]');
    for (i = 0; i < modals.length; i++) {
      if (modals[i] !== dialog && isVisible(modals[i])) return true;
    }
    return false;
  }

  function isTyping() {
    var el = document.activeElement;
    if (!el) return false;
    if (el.isContentEditable) return true;
    return /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName);
  }

  function suppressed() {
    return fired || seen() || onBlockedPage() || otherOverlayOpen() || isTyping();
  }

  function disarm() {
    document.removeEventListener('mouseout', onMouseOut, true);
    window.removeEventListener('popstate', onPopState);
    backArmed = false;
  }

  function show() {
    if (suppressed()) return false;
    fired = true;
    markSeen(); /* recorded before opening: strictly once per session */
    disarm();
    try {
      dialog.showModal();
    } catch (e) {
      return false;
    }
    var target = dialog.querySelector('[data-mrz-initial-focus]');
    if (target) {
      try { target.focus(); } catch (e) {}
    }
    return true;
  }

  /* ---------- desktop exit intent ---------- */
  function onMouseOut(event) {
    if (event.relatedTarget || event.toElement) return; /* still inside the page */
    if (typeof event.clientY === 'number' && event.clientY > 16) return;
    show();
  }

  /* ---------- touch: single self-disarming history sentinel ---------- */
  function armBack() {
    if (backArmed || seen() || onBlockedPage()) return;
    try {
      window.history.pushState({ mrzExitSentinel: 1 }, '');
    } catch (e) {
      return;
    }
    backArmed = true;
    window.addEventListener('popstate', onPopState);
  }

  function onPopState() {
    window.removeEventListener('popstate', onPopState); /* one shot, never re-armed */
    backArmed = false;
    if (show()) return;
    /* Offer could not be shown, so the sentinel absorbed a Back press we did
       not use. Complete the customer's navigation instead of trapping them. */
    try { window.history.back(); } catch (e) {}
  }

  function armBackWhenEngaged() {
    var done = false;
    var timer;
    function go() {
      if (done) return;
      done = true;
      window.clearTimeout(timer);
      window.removeEventListener('scroll', go);
      armBack();
    }
    timer = window.setTimeout(go, 8000);
    window.addEventListener('scroll', go, { passive: true });
  }

  /* ---------- dismissal ---------- */
  dialog.addEventListener('close', markSeen);
  dialog.addEventListener('cancel', markSeen); /* Escape */

  dialog.addEventListener('click', function (event) {
    var closer = event.target.closest ? event.target.closest('[data-mrz-close]') : null;
    if (closer) {
      event.preventDefault();
      dialog.close();
      return;
    }
    if (event.target === dialog) dialog.close(); /* backdrop */
  });

  /* ---------- copy code ---------- */
  var copyBtn = dialog.querySelector('[data-mrz-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var status = dialog.querySelector('[data-mrz-copy-status]');
      function done(ok) {
        if (status) status.textContent = ok ? 'Code copied' : 'Select the code to copy it';
      }
      var code = copyBtn.getAttribute('data-mrz-copy');
      function selectCode() {
        var el = dialog.querySelector('.mrz-exit__code');
        if (!el || !window.getSelection || !document.createRange) return;
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () { done(true); }, function () {
          selectCode();
          done(false);
        });
      } else {
        selectCode();
        done(false);
      }
    });
  }

  /* ---------- init ---------- */
  if (seen() || onBlockedPage()) return;

  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', onMouseOut, true);
  } else {
    armBackWhenEngaged();
  }
})();
